import { useEffect, useState } from "react";
import "../MainBox.css";
import PBIReport from "../../PowerBI/PBIReport";
import PBIReportFilter from "../../PowerBI/PBIReportFilter";
import PackBI from "../../PowerBI/packBI";
import ComponentsOnHandUS from "./ComponentsOnHand-US";
import Forecast from "./Forecast-US";
import NotesUS from "./Notes-US";
import Packs from "../DK/Packs";
import OverView from "./OverView-US";
import VisualFilterPBI from "../../PowerBI/VisualFilterPBI";
import ReprintsInputUS from "./ReprintsInput-US";
import SpecFormUS from "./SpecForm-US";
import PRHLoader from "../../lib/PRHLoader";
import Series from "./Series";


export default function accordUS(props) {
    //const [activeIndex, setActiveIndex] = useState([]);
    const [childrenISBNs, setChildrenISBNs] = useState([]);
    const [billingId, setBillingId] = useState(null);
    const [billingFilter, setBillingFilter] = useState(null);
    const [posId, setPosId] = useState(null);
    const [posfilter, setPosFilter] = useState(null);
    const [prodSpecsId, setProdSpecsId] = useState(null);
    const [prodSpecsFilter, setProdSpecsFilter] = useState(null);
    const [marketingId, setMarketingId] = useState(null);
    const [marketingFilter, setMarketingFilter] = useState(null);
    const [packInfo, setPackInfo] = useState(null);
    const handleAccordionClick = (index) => {
        const indexExists = props?.USAccordSetting.includes(index);
        //const indexExists = activeIndex.includes(index);
        if (indexExists) {
            //setActiveIndex(activeIndex.filter((i) => i != index));
            props.setUSAccordSetting(props?.USAccordSetting.filter((i) => i != index));
        } else {
            //setActiveIndex([...activeIndex, index]);
            props.setUSAccordSetting([...props?.USAccordSetting, index]);
        }
    };

    useEffect(() => {
        let pChildrenISBNs = props.metaData?.packChildrenISBNs ?? [];
        if (props.ISBNId) {
            pChildrenISBNs.push(props.ISBNId);
        }
        else if (props.ISBNs && props.ISBNs.length > 0) {
            pChildrenISBNs.push(...props.ISBNs);
        }
        setChildrenISBNs(pChildrenISBNs);

        if (props.metaData && props.metaData?.packInfo != null && props.metaData?.packInfo != "") {
            setPackInfo(props.metaData.packInfo);
        }
    }, [props.metaData])

    useEffect(() => {
        if (props?.reportData && props?.reportData.length > 0) {            
            let newReportData = [];
            props?.reportData.forEach(item => {
                newReportData.push({ ...item, filters: JSON.parse(item.filters) });
            })
           

            setBillingId(props?.reportData.find(report => report?.reportName === "Billings"));
            setPosId(props?.reportData.find(report => report?.reportName === "POS"));
            setProdSpecsId(props?.reportData.find(report => report?.reportName === "Standard"));
            setMarketingId(props?.reportData.find(report => report?.reportName === "Marketing"));
            setMarketingFilter(JSON.parse(props?.reportData?.find(report => report?.reportName === "Marketing")?.filters ?? null));
            setBillingFilter(JSON.parse(props?.reportData?.find(report => report?.reportName === "Billings")?.filters ?? null));
            setPosFilter(JSON.parse(props?.reportData?.find(report => report?.reportName === "POS")?.filters ?? null));
            setProdSpecsFilter(JSON.parse(props?.reportData?.find(report => report?.reportName === "Standard")?.filters ?? null));
        }
    }, [props.reportData])

 /*   useEffect(() => {
        setActiveIndex(props?.USAccordSetting);
    }, [props?.USAccordSetting])*/
    return (
        <div className="accordion">
            <div className={`accordion-item ${props?.USAccordSetting.includes(0) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(0)}>
                    Notes
                </div>
                <div className="accordion-content accordian-border">
                    <NotesUS upn={props.upn} ISBNId={props.ISBNId} metaData={props.metaData} isMetaLoading={props.isMetaLoading} isEditable={props.isEditable} />
                </div>
            </div>
            <div className={`accordion-item ${props?.USAccordSetting.includes(1) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(1)}>
                    Forecast & Shipments
                </div>
                <div className="accordion-content accordian-border">
                < Forecast ISBNId={props.ISBNId} upn={props.upn} metaData={props.metaData} isEditable={props.isEditable} isEditable={props.isEditable} isMetaLoading={props.isMetaLoading} />
                        {billingId?.reportId && <>
                            <p className="accord-pbi-label ml-2 mt-4 pt-2">Shipments</p>
                            <PBIReportFilter
                                BiToken={props.BiToken}
                                name='Billings'
                                //  reportId="055b50df-d348-448c-b3ff-cb82086a46a7"
                                reportId={billingId?.reportId}
                                filterValues={billingFilter}

                            // filterValue={props.ISBNId}
                            /></>}
                    
                </div>
            </div>

            <div className={`accordion-item ${props?.USAccordSetting.includes(2) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(2)}>
                    Stock Overview
                </div>
                <div className="accordion-content accordian-border">
                    <br />
                    <OverView ISBNId={props.ISBNId} metaData={props.metaData}></OverView>
                    <div style={{ paddingBottom: "20px" }}>
                        <a target="_blank" style={{ display: "inline", marginRight: "65px", marginLeft: "20px" }} href={`https://myhouse.penguinrandomhouse.com/title.cfm?inv_drill=&isbn=${props.ISBNId}&tab=15`}>Inventory Overview</a>
                        <a target="_blank" style={{ display: "inline", marginRight: "65px" }} href={`https://myhouse.penguinrandomhouse.com/title.cfm?isbn=${props.ISBNId}&tab=15&cache=false&inv_drill=GI`}>Inventory Detail</a>
                        <a target="_blank" style={{ display: "inline" }} href={`https://myhouse.penguinrandomhouse.com/title.cfm?isbn=${props.ISBNId}&tab=15&cache=false&inv_drill=SO`}>Open Sales Orders</a>
                    </div>
                </div>
            </div>

           <div className={`accordion-item ${props?.USAccordSetting.includes(3) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(3)}>
                    POS Demand
                </div>
                <div className="accordion-content accordian-border">
                    
                    <hr />
                    {posId?.reportId &&
                        <PBIReportFilter
                            BiToken={props.BiToken}
                            name='POS'
                            //  reportId="055b50df-d348-448c-b3ff-cb82086a46a7"
                            reportId={posId?.reportId}
                            filterValues={posfilter}
                        // filterValue={props.ISBNId}
                        />}
                   
                </div>
            </div>

            <div className={`accordion-item ${props?.USAccordSetting.includes(4) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(4)}>
                    Reprint Inputs
                </div>
                <div className="accordion-content accordian-border ">
                    <ReprintsInputUS isEditable={props.isEditable} ISBNId={props.ISBNId} upn={props.upn} metaData={props.metaData} />
                </div>
            </div>
            < div className={`accordion-item ${props?.USAccordSetting.includes(5) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(5)}>
                    Components on Hand
                </div>
                <div className="accordion-content accordian-border">
                    <ComponentsOnHandUS ISBNId={props.ISBNId} metaData={props.metaData} />
                </div>
            </div>
          <div className={`accordion-item ${props?.USAccordSetting.includes(6) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(6)}>
                 Production Specs
                </div>
                <div className="accordion-content accordian-border">
                    <SpecFormUS metaData={props.metaData} ISBNId={props.ISBNId} isEditable={props.isEditable} />
          
                        <div className="pbi-report">
                        {prodSpecsId?.reportId  && 
                            <PBIReportFilter
                                BiToken={props.BiToken}
                                name='Standard flux'
                                //  reportId="055b50df-d348-448c-b3ff-cb82086a46a7"
                                reportId={prodSpecsId?.reportId}
                                filterValues={prodSpecsFilter}
                            // filterValue={props.ISBNId}
                            />
                        }  
                        </div>
                </div>
            </div>
            < div className={`accordion-item ${props?.USAccordSetting.includes(9) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(9)}>
                    Series & Author Works
                </div>
                <div className="accordion-content accordian-border">
                    <Series ISBNId={props.ISBNId} metaData={props.metaData} isbnData={props?.isbnData} setIsbnData={props?.setIsbnData} upn={props.upn} isEditable={props?.isEditable} />
                </div>
            </div>
            <div className={`accordion-item ${props?.USAccordSetting.includes(7) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(7)}>
                    Title Family & Packs
                </div>
                <div className="accordion-content accordian-border">
                    <Packs metaData={props.metaData}></Packs>
                    {(packInfo != null && packInfo === 'P') && <>
                        <div className="pbi-report">
                            <PackBI
                                BiToken={props.BiToken}
                                name='Inventory Pack Billing'
                                reportId='50dea56e-a52b-4c1c-8915-0b0e40230df3'
                                filterTable='Product Hierarchy'
                                filterColumn='ISBN'
                                filterValues={childrenISBNs}
                            />
                        </div>
                    </>
                    }
                    {(packInfo != null && (packInfo === 'C' || packInfo === 'R')) && <>
                        <div className="pbi-report">
                            <PBIReport
                                BiToken={props.BiToken}
                                name='Inventory Component Billing'
                                reportId="8a034fe9-bbef-4a86-83b2-3f7a48a3e347"
                                filterTable="Product Hierarchy"
                                filterColumn="ISBN"
                                filterValues={props.ISBNs}
                                filterValue={props.ISBNId}
                            />
                        </div>
                    </>
                    }
                </div>
            </div>
            <div className={`accordion-item ${props?.USAccordSetting.includes(8) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(8)}>
                    Marketing & Publicity
                </div>
                <div className="accordion-content accordian-border">
                    <div className="accordion-content accordian-border">
                        {marketingId?.reportId && 
            <PBIReportFilter
                            BiToken={props.BiToken}
                            name='Marketing'
                            reportId={marketingId?.reportId}
                            filterValues={marketingFilter}
                    />
                        }
                    </div>
                </div>
            </div>
            {/* <div className={`accordion-item ${props?.USAccordSetting.includes(9) ? 'active' : ''}`}>
                <div className="accordion-header" onClick={() => handleAccordionClick(9)}>
                    Marketing Events
                </div>
                <div className="accordion-content accordian-border">
                    <div className="accordion-content accordian-border">
   
                            <VisualFilterPBI
                                BiToken={props.BiToken}
                                name='Marketing'
                            reportId={'b60f80a3-4be2-4b8e-af4f-36fa2ac78aba'}
                            visualFilters={[{
                                name: "Marketing Events", filters: [{
                                    $schema: 'http://powerbi.com/product/schema#basic',
                                    target: {
                                        table: 'Marketing and Publicity',
                                        column: 'ISBN',
                                    }, operator: 'In',
                                    values: [props.ISBNId],
                                }]
                            }]}
                            />
                        
                    </div>
                </div>
            </div>*/}
        </div>
    );
}